import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { ContentUpgrades } from "@swizec/gatsby-theme-course-platform";
export const _frontmatter = {
  "title": "Computer science is not software engineering",
  "description": "Wow, college was such a waste of time ... when did you ever invert a binary tree outside of an interview? Honestly I never inverted a binary tree in college either ☹️",
  "published": "2020-10-02T00:00:00.000Z",
  "content_upgrade": "SeniorMindset",
  "hero": "./img/screenshot-1601656385216.png",
  "categories": "Opinions, Learning, Mindset"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <blockquote>
      <p parentName="blockquote">{`Wow, college was such a waste of time ... when did you ever invert a binary tree outside of an interview?`}</p>
    </blockquote>
    <p>{`Honestly I never inverted a binary tree in college either ☹️`}</p>
    <p>{`Maybe I skipped that day ... I was a terrible student. The kind who oversleeps 10 minutes and says `}<em parentName="p">{`"Ah screw it, might as well not go to class today"`}</em></p>
    <p>{`And despite working at it for 5 years and never graduating,`}<sup parentName="p" {...{
        "id": "fnref-1"
      }}><a parentName="sup" {...{
          "href": "#fn-1",
          "className": "footnote-ref"
        }}>{`1`}</a></sup>{` studying computer science was one of the best things I ever did for my career. We talked about it with Noah Gibbs on his new podcast, `}<a parentName="p" {...{
        "href": "http://justtheusefulbits.com/jtub/swizec-teller-the-value-of-theory-and-why-not-to-build-an-analytics-service/"
      }}>{`Computer Science: Just the Useful Bits`}</a>{`. You should give it a listen.`}</p>
    <p>{`Computer science didn't prepare me for software engineering. This is true.`}</p>
    <p>{`There were classes about engineering. Freshman year. Intro to Java 101. Sophomore year, product management blow off class.`}</p>
    <p>{`And that's it. 5 years, 10 semesters, 40 classes. 2 on software engineering`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media2.giphy.com/media/UPXjMmG8S7iFFziXhk/giphy-loop.mp4?cid=7cf28b0fqqf56ppfl4ha0g12q520uun6lfntidzvunudk3az&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`To be perfectly honest, the air of superiority in my college was ... thick. We looked down on software engineers.`}</p>
    <p>{`We were computer scientists damn it! Going into industry is a waste of talent. We're here to advance the field!!`}</p>
    <ContentUpgrades.SeniorMindset />
    <p>{`Then we discovered money. We all work in startups building technically boring apps where the biggest challenge is how to engineer this thing so a large team can work together without killing each other 😅`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "740px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/a949c0d6d91143aa9e5193fa5b177fc9/50383/XKCD-Academia-vs-Businessi06da3.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "51.569506726457405%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'206\\'%20viewBox=\\'0%200%20400%20206\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M272%201l-1%203c0%202%200%202-8%202h-8v18l-1%2017c-2-1-12%202-13%203s-1%201%201%201l7-2h6v52h144l1%2011v11l-44-1h-45v-2c0-2-1-3-12-3-20-2-24-1-25%202%200%203%200%203-9%203l-9%201-1%2014v14h-6l-7-2c-2%200-2%200-1%201s11%204%2013%203l1%2029v30h145V6h-89V1l-20-1-19%201m1%201l-1%203%201%202%201-2c0-2%202-4%203-2h2c2-1%203%200%201%202v1c1%201%201%200%202-2s1-2%202-1l2%201c1-2%208-2%2010-1h7c1%200%203%201%203%203%201%202%200%203-1%201h-6c-2-2-3-2-3-1l-1%202a188%20188%200%200110%201c4%201%204%201%204-3V2c-1-2-36-1-36%200m-17%2049v43h143V7h-44c-43%200-44%200-44%202-1%202-2%202-20%202s-19%200-20-2c0-2-1-2-8-2h-7v44m124-29h-10c-8%200-8%200-8%203%200%202%200%202%203%202h21l3-1h4l1%201h2c1%201%201%201%201-1l-1-3h-2l-5-1h-9m-48%209l-1%203c0%202%200%202%206%202l5-1v-3l1%202c1%202%204%203%204%201h7c1%201%204%201%204-1h-3l1-2-4-1c-5%200-6%201-6%202l-1%202v-2l-2-2c-3-1-5%200-5%202l-1%201v-2l-1-1h-4m-47%2012c-3%202-3%208%200%2011%202%202%202%203%200%206-2%206-2%2012-1%2012l1-4%201-3c2-2-1%2014-4%2023l1%202%204-16c0-4%202-1%204%208%201%205%203%208%203%207l-3-10-3-12c0-3%200-3%202%201%202%205%203%203%200-4-2-6-2-7%200-7%204%200%207-11%204-14-3-2-7-2-9%200m0%201c-2%202-1%207%201%209%204%204%208%201%208-4s-6-8-9-5m66%204c-2%202-2%203-2%206%201%204%205%208%207%207s1%201%200%202c-2%201-5%200-8-3-3-2-4-2-5-1s-1%201%201%202l4%203c1%202%202%203%203%202l2%201c2%202%203%201%205-2l1-3v3c-1%205-2%206-7%207l-5%201v-8h-8c-7%200-8%200-7-1v-2l-1-1c1-1-2-3-4-2-2%200-2%200-1%201%202%200%201%201-3%202-6%202-6%202-6%2016v13h30v-2c0-3%202-5%202-3v-4c-1-3-1-3%202-3%202%200%202%200%201%201v2c1%200%201%202-1%205l-2%205%202-1h7c2%202%202-1%201-4-3-4-2-6%200-7%202%200%207-9%208-13%200-4-3-4-4%200-1%203-1%204-2%203l1-5c2-3%202-3%200-3-2%201-2-4%200-8%203-6%202-7-3-8l-8%202M1%2055l43%201h43v92H44l-43%201%2044%201h44V55l-44-1-44%201m92%200v48l1%2047h110v-50l4%202h5l-5-2c-4-1-4-1-4-6s0-5%204-6l5-2h-5l-4%202V55l-55-1-56%201m2%2047v46h6c6%200%206%200%205-2a345%20345%200%2001-5-17l1-2c-2-5%202-7%205-3%201%202%201%202%201-2l-3-7c-7-7-5-20%204-22%2012-2%2018%205%2014%2017-3%206-5%208-10%208h-4l2%205c4%207%2015%2015%2022%2016l8%205c4%205%206%205%206%200%200-4%200-4-4-4l-4-1c-1-1%204-5%206-5l2-1c0-2-1-2-4-2s-4%200-4-2l2-2c3%200%203%200%203-4s1-5%203-5%202%200%202%204v5h4l10-1%206-1-1-1c-4%202-5%200-4-4a1128%201128%200%20008-32c4%201%205%206%202%2022l-2%2013%202%202%203%201h2c1%200%202-1%202-3%201-5%205-6%205-1%200%203%200%204%202%204s2-1%202-3c0-3%201-4%202-4%202-1%204%201%204%204l2%204c2%200%202%201%202%205a607%20607%200%20002-30V56H95v46m66-43l-6%201h-10c-1-1-1-1-1%202%200%202%200%202%201%201h8c0-1%201-1%202%201h8c4%200%205-1%205-3%200-3-1-3-7-2m-43%209h-2l-9-1c-8%200-9%200-9%202%201%203%202%204%203%201h2c0%202%201%202%203%201h2c1%201%208%202%209%201h7l5-1h-1l-1-1%201-2c1-1%200-1-1-1l-2%202h-1c-1-3-3-4-6-1m12%200l3%203c1-1%201%200%201%201h3c2%201%2015%200%2016-1h2c1%202%203%201%202-1-1-3-9-4-10-1l-1%201c0-2-4-4-5-2h-11m188%2011v11h27v-9l1-11v-2h-28v11M109%2095c-7%201-8%2012-3%2018%202%203%208%205%2011%203%205-3%208-17%203-20-2-1-9-2-11-1m-52%207c0%202%200%202-1%201-1-3-3%2011-2%2013%200%202-1%202-3%202-3%200-4%200-4-2-1-3-3-4-4-1l-1%203c-1%203-1%203%201%203%202%201%202%201%200%202-4%201-4%203%200%203%202%200%202%200%202%203%200%202%200%202-2%201l-3-2-5-3c-5-2-11-9-8-9l2-1-2-1c-3%200-4%201-3%203%200%201%200%202-1%201l-2%201c-3%205%202%2014%208%2015l4%201-4%206-1%202h7c4%201%205%200%203-3s-3-4%200-6c1-2%201-2-4-2-3%200-4%200-3-1h9c1-2%206%207%205%2010v2h24v-25l-1-4c-1-3-7-1-7%202l-1%202c-2%200-2-3-1-9v-7c0-3-3-3-2%200m219%2014c0%203%201%204%202%204a849%20849%200%200115-2h-1c0%201-11%201-12-1l-2-1%201%202v1c-2%200-2-1-2-3%200-4%204-4%205-1%200%202%202%203%202%201v-2l3-1%201%201v2l1-1h5c0-1%201-2%202-1a153%20153%200%200010%201c-1%200-1%201%201%202v2c-1%201-1%201%201%201s2%200%202-4l-1-3-16-1h-17v4m-20%2046v43h143v-87h-44l-44%201c0%203-2%203-20%203-15%200-16%200-16-2-1-2-2-2-10-2h-9v44M47%20126v16h20v-5l1-11%201-5H47v5m251-2l-1%203c0%202%201%203%203%201h1c0%201%207%202%2013%201h5l2-2%201%201v1c1%201%201%200%201-1%200-2%200-3-3-3a3184%203184%200%2001-22-1m-139%207c-11%200-11%200-11%2010v7h50v-17h-12a270%20270%200%2001-27%200m124%2021c-2%203-2%206%200%2010%201%202%202%203%200%207-2%207-2%2011-1%2011l1-2%201-4c2-4%200%2011-2%2019l-1%208%203-11c2-7%202-7%204%202%201%207%203%2011%203%208l-2-12c-3-12-4-19-2-13l2%205v-6c-3-6-3-9-2-9%203%202%207-3%207-8%200-6-8-9-11-5m2%200c-3%201-3%207%200%2010%203%204%208%201%208-6%200-3-5-6-8-4m70%203c-4%203-3%2012%201%2012%202%200%202%200%201%202-2%202-4%201-8-3-2-2-3-3-4-2-2%201-1%202%205%205%204%203%205%203%207%201%202-1%202-1%201%203-2%204-5%206-8%206l-4%201h-1v-9h-9l-9-1h-2c-2%202-3%201-4-2-3-4-4-4-4%201%200%202%200%203-2%203s-2%201-2%205l-1%2014v10h6l16-1h11v-6c0-8%200-8%204-7%204%202%204%202%201%208-2%205-2%209%200%206%202-2%207-3%209-1h2c0-2%200-3-2-4l-2-1-3%201c-3%200-3-1-2-2l1-4c0-2%200-2%201%201l2%203v-3c0-3%200-4%203-5%202%200%203-2%205-7%202-6%202-9-1-9l-2-2%201-2%203-8c-1-4-6-6-10-3m-32%2020l-8%201-1%2012v12l14-1%2015-1%201-12v-11l-6-1-15%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a949c0d6d91143aa9e5193fa5b177fc9/ca0a1/XKCD-Academia-vs-Businessi06da3.webp 223w", "/static/a949c0d6d91143aa9e5193fa5b177fc9/75680/XKCD-Academia-vs-Businessi06da3.webp 445w", "/static/a949c0d6d91143aa9e5193fa5b177fc9/ca4a8/XKCD-Academia-vs-Businessi06da3.webp 740w"],
                "sizes": "(max-width: 740px) 100vw, 740px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a949c0d6d91143aa9e5193fa5b177fc9/e92b6/XKCD-Academia-vs-Businessi06da3.png 223w", "/static/a949c0d6d91143aa9e5193fa5b177fc9/e66bf/XKCD-Academia-vs-Businessi06da3.png 445w", "/static/a949c0d6d91143aa9e5193fa5b177fc9/50383/XKCD-Academia-vs-Businessi06da3.png 740w"],
                "sizes": "(max-width: 740px) 100vw, 740px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a949c0d6d91143aa9e5193fa5b177fc9/50383/XKCD-Academia-vs-Businessi06da3.png",
                "alt": "XKCD: Academia vs Business",
                "title": "XKCD: Academia vs Business",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`XKCD: Academia vs Business`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "why-study-computer-science-then"
    }}>{`Why study computer science then?`}</h2>
    <p>{`What I got from computer science are the timeless truths of our field. And a lot of math.`}</p>
    <p>{`Everything from how transistors work to proving equivalence between different theories of computation. The `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/why-understanding-beats-knowledge/"
      }}>{`understanding that beats knowledge`}</a>{`. The core truths that don't change every 5 years.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/38d0eeac543a6d3cccd0df24ea80095e/2bef9/Understanding-wins-in-the-long-term03di4i.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "55.15695067264574%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'221\\'%20viewBox=\\'0%200%20400%20221\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M44%2039l-1%2019-4%2065-3%202-3%202h3c4-1%204-3%200%2024l-2%2021h-6c-8%200-8%202%200%202h5l-1%204c-1%206-1%206-6%206-5-1-14%200-14%201h19v3c-2%208-2%2012-1%2012l1-8%202-6%2012-1%2028-2c30-2%2047-2%20102-1a525%20525%200%200197%203%201745%201745%200%2000-239-1l1-5c0-6%200-5%2017-7a361%20361%200%2000-12%200h-4v-4a2311%202311%200%20006-42l85-23a1726%201726%200%2001139-29h4l-3%202-2%204%204-3c2-4%203-4%2023-8a485%20485%200%2001-2-1c-12%202-15%203-16%202h-2l-29%207c-93%2018-99%2020-155%2035-46%2012-46%2012-46%2010a4749%204749%200%20013-83m200%2095c-3%205-2%206%207%206l7-1-2-2c-1-1-1-1%201-2%203-1%204-1%204%201v2l1-2%202-2%201-1c0-2-6-1-10%201-4%201-4%202-1%204%202%201%202%201%200%201l-5-1c-2%200-2%200-1-1%202-1%203-4%200-4-2-1-3-1-4%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/38d0eeac543a6d3cccd0df24ea80095e/ca0a1/Understanding-wins-in-the-long-term03di4i.webp 223w", "/static/38d0eeac543a6d3cccd0df24ea80095e/75680/Understanding-wins-in-the-long-term03di4i.webp 445w", "/static/38d0eeac543a6d3cccd0df24ea80095e/8d1ba/Understanding-wins-in-the-long-term03di4i.webp 890w", "/static/38d0eeac543a6d3cccd0df24ea80095e/a9a89/Understanding-wins-in-the-long-term03di4i.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/38d0eeac543a6d3cccd0df24ea80095e/e92b6/Understanding-wins-in-the-long-term03di4i.png 223w", "/static/38d0eeac543a6d3cccd0df24ea80095e/e66bf/Understanding-wins-in-the-long-term03di4i.png 445w", "/static/38d0eeac543a6d3cccd0df24ea80095e/4ef49/Understanding-wins-in-the-long-term03di4i.png 890w", "/static/38d0eeac543a6d3cccd0df24ea80095e/2bef9/Understanding-wins-in-the-long-term03di4i.png 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/38d0eeac543a6d3cccd0df24ea80095e/4ef49/Understanding-wins-in-the-long-term03di4i.png",
                "alt": "Understanding wins in the long term",
                "title": "Understanding wins in the long term",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Understanding wins in the long term`}</figcaption>{`
  `}</figure></p>
    <p>{`And that's been invaluable my friend. It changed everything.`}</p>
    <p>{`I started as a self-taught dev and I remember what it's like. When you know every tree in detail and don't realize there's a whole forest. That trees work together. That they're all the same.`}</p>
    <p>{`A tree is a tree is a tree. Some have leaves, some have needles, some are tall, some are short. And they're all trees.`}</p>
    <p>{`Just like JavaScript frameworks.`}</p>
    <p>{`Some have JSX, some have templates, some split CSS and JS, some merge it all together. Some like observers, others like passing props. And they all make you faster.`}</p>
    <h2 {...{
      "id": "how-to-get-the-most-out-of-a-comp-sci-degree"
    }}>{`How to get the most out of a comp sci degree?`}</h2>
    <p>{`If you have a choice between a comp sci and a software engineering career, go for comp sci. One prepares you for a wide swath of careers, the other gives you tools for today.`}</p>
    <p>{`Bootcamps in particular are all about `}<em parentName="p">{`get job NOW`}</em>{`. Oh you need skills that work 5 years from now? Good luck.`}</p>
    <p>{`Comp sci is forever.`}</p>
    <p>{`Well there was that one time I taught my databases professor about `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/NoSQL"
      }}>{`NoSQL`}</a>{` and he was shooketh. Asked me to do a seminar and the entire class hated me when that material was on the exam.`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media4.giphy.com/media/3ohzdYJK1wAdPWVk88/giphy-loop.mp4?cid=7cf28b0fctj6blo17n0u2j9mabnhkum43v4mh8xoq2mx647n&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`Next year NoSQL was part of the official curriculum 🤘`}</p>
    <p>{`That was 2010. Now it's 2020 and NoSQL is a strong `}<em parentName="p">{`you shouldn't use this unless you have a very specific use-case or reason in mind`}</em>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Relational_database"
      }}>{`Relational databases`}</a>{`, a comp sci thing, are the default way to store data for 50 years and counting.`}</p>
    <p><strong parentName="p">{`Make sure you code on the side!`}</strong></p>
    <p>{`That's the trick. That's how you get the most out of your degree. `}<em parentName="p">{`Apply your skills and knowledge in real time`}</em>{`.`}</p>
    <p>{`You can see the effect of that on my old articles. Like when I built a `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/a-turing-machine-in-133-bytes-of-javascript/"
      }}>{`Turing machine simulator in 133 bytes of JavaScript`}</a>{`. Yes it's useless. Learned a lot though.`}</p>
    <p>{`Even better if you can launch an app, get a freelance gig, moonlight at an agency, anything that teaches you software engineering. `}<strong parentName="p">{`Engineering is best learned on the job.`}</strong></p>
    <p>{`If you're an old fart like me, pick up a CS book once in a while. Read an article. Study a paper.`}</p>
    <p>{`Shannon's `}<a parentName="p" {...{
        "href": "http://people.math.harvard.edu/~ctm/home/text/others/shannon/entropy/entropy.pdf"
      }}>{`A Mathematical Theory of Communication`}</a>{` is a fantastic paper with broad applications to modern web engineering and systems. I read it every few years.`}</p>
    <h2 {...{
      "id": "what-if-you-never-studied-comp-sci"
    }}>{`What if you never studied comp sci?`}</h2>
    <p>{`I bet you know more than you realize!`}</p>
    <p>{`You pick up lots of computer science on the job. Things you never even realized were part of comp sci.`}</p>
    <p>{`Like the fact that you can't parse HTML with Regex, or that reading from a database is slower than from memory. Or that you should have a cache and avoid slow operations.`}</p>
    <p>{`And that async code is faster than sequential code, but `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Amdahl%27s_law"
      }}>{`never faster than the slowest non-parallelized part`}</a>{`.`}</p>
    <p>{`I don't have an answer for how to pick up computer science later. And I don't know that you need to. But it won't hurt.`}</p>
    <p>{`Try a textbook or a good paper like `}<a parentName="p" {...{
        "href": "http://people.math.harvard.edu/~ctm/home/text/others/shannon/entropy/entropy.pdf"
      }}>{`Shannon's above`}</a>{` (very approachable). Tannenbaum's `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Modern_Operating_Systems"
      }}>{`Modern Operating Systems`}</a>{` is a great practical place to start.`}</p>
    <p>{`You should listen to `}<a parentName="p" {...{
        "href": "http://justtheusefulbits.com/jtub/swizec-teller-the-value-of-theory-and-why-not-to-build-an-analytics-service/"
      }}>{`the full podcast episode with Noah Gibbs`}</a>{` where we talked about what comp sci was like for me and why I think it was great.`}</p>
    <p>{`Happy Friday ❤️`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p><sup parentName="p" {...{
        "id": "fnref-1"
      }}><a parentName="sup" {...{
          "href": "#fn-1",
          "className": "footnote-ref"
        }}>{`1`}</a></sup>{` I dropped out in 2012 after missing graduation by 2 credits. The credits were in separate semesters and I'd have to stay in school for a whole 'nother year. Decided to go full time on my freelancing business instead.`}</p>
    <p>{`PS: the credits were for a notoriously difficult freshman course in low level computer architecture. CPU pipelines and such. Prof was one of the college founders 💪`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      